import { Link } from "react-router-dom"

const VehicleInfoCell = ({ data = {} }) => {
  if (!data || Object.keys(data).length === 0) return null

  const {
    stock_id,
    full_chassis,
    primary_image,
    brand,
    model,
    year,
    package: pkg,
    exterior_color,
    engine_type,
    engine_c_c,
    key_type,
    auction_grade,
    mileage,
  } = data

  const chassisLink = `/stock-list/${full_chassis}/view`
  const stockLink = `/stock-list/${stock_id}/view`

  return (
    <div className="d-flex flex-column gap-1">
      {/* Vehicle Title with Image */}
      <div className="d-flex align-items-center gap-2">
        {primary_image && (
          <img
            src={primary_image}
            alt={`${brand?.name} ${model?.name}`}
            className="rounded"
            style={{ width: "80px", height: "60px", objectFit: "cover" }}
          />
        )}
        <div>
          <div className="fw-semibold text-dark">
            <i className="bx bx-car me-1"></i>
            {brand?.name} {model?.name} {engine_type?.name}{" "}
            {pkg?.name ? <span className="text-secondary">({pkg?.name})</span> : null}{" "}
            <span className="text-muted">[{year?.name}]</span>
          </div>

          {/* Detail Line */}
          <div className="small mt-1">
            <i className="bx bx-cog me-1"></i>
            {engine_c_c?.name}cc •{" "}
            <i className="bx bx-palette me-1"></i>
            {exterior_color?.name} • <i className="bx bx-check-shield me-1"></i>
            Grade {auction_grade?.name} • <i className="bx bx-key me-1"></i>
            {key_type?.name}{" "}
            {mileage != null && (
              <>
                • <i className="bx bx-tachometer me-1"></i>
                {mileage.toLocaleString()} km
              </>
            )}
          </div>

          {/* Highlighted Identifiers with Links */}
          <div className="small mt-1">
            <strong className="text-primary">
              <i className="bx bx-hash me-1"></i>
              <Link to={stockLink}>{stock_id}</Link>
            </strong>{" "}
            •{" "}
            <strong className="text-success">
              <i className="bx bx-barcode me-1"></i>
              <Link to={chassisLink}>{full_chassis}</Link>
            </strong>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VehicleInfoCell
